import { render, staticRenderFns } from "./CtrlSoko.vue?vue&type=template&id=8dffa392&"
import script from "./CtrlSoko.vue?vue&type=script&lang=ts&"
export * from "./CtrlSoko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports